export default {
  uploadFile: 'Upload File',
  beforeOnline: 'TreasureNFT dev',
  treasureTitle: 'TreasureNFT',
  turkeyTitle: 'minterests',

  // login
  register: 'Melden Sie sich an',
  fail: 'Fehlgeschlagen',
  login: 'Anmeldung',
  account: 'Nutzername',
  password: 'Passwort',
  newPassword: 'Neues Kennwort',
  email: 'Email',
  confirmPW: 'Bestätige das Passwort',
  emailValid: 'E-Mail-Verifizierung',
  phone: 'Mobil-Nr.',
  phoneValid: 'Mobile Verifizierung',
  googleValid: 'Google-Bestätigung',
  nickname: 'Spitzname',
  inviteCode: 'Referenzcode',
  gender: 'Geschlecht',
  birthday: 'Geburtstag',
  male: 'Männlich',
  female: 'Weiblich',
  code: 'Bestätigungscode',
  forgot: 'Passwort vergessen',
  Login: 'Anmeldung',
  resetPW: 'Passwort zurücksetzen',
  oldPassword: 'Altes Kennwort',
  haveAccount: 'Ein Konto haben?',
  pleaseGotoMailboxReceive: 'Erhalten Sie den Bestätigungscode im Postfach',
  pleasePhoneReceive: 'Bestätigungscode erfolgreich gesendet.',
  accountOrMailboxError: 'Ungültiges Konto oder ungültige E-Mail-Adresse',
  welcomeBack: 'Willkommen zurück',
  checkin: 'Einchecken',
  dailyMissionRewards: 'Tägliche Aufgabenbelohnung',
  signSuccessfully: 'Erfolgreicher Check-in',
  more: 'Mehr',
  pleaseMailboxReceiveNewPassword: 'Das neue Passwort wird an Ihre E-Mail-Adresse gesendet.',
  forgotModal: 'Passwort vergessen',

  // nav
  Home: 'Heim',
  Discover: 'Entdecken',
  Explore: 'Erkunden',
  Collection: 'Sammlung',
  Trade: 'Reservieren',
  Account: 'Konto',
  History: 'Handelsgeschichte',
  Team: 'Team',
  GroupHistory: 'Gruppengeschichte',
  explore: 'Erkunden',
  Notification_nav: 'Bestelldatensatz',
  TopPicks: 'Alle',
  Sellingout: 'Warte darauf, gelistet zu werden',
  BrandSpotlight: 'Wartet darauf, verkauft zu werden',
  SoldOut: 'Verkauft',
  Wallet: 'Geldbörse',
  language: 'Sprache',
  sideMenuMember: 'Mitgliedsname}',
  userCenter: 'Profil',
  shareCenter: 'Verteilzentrum',
  pointRecord: 'Punkteverlauf',
  walletRecharge: 'Kaution',
  walletWithdraw: 'Zurückziehen',

  // main
  'index-h1': 'Verdienen Sie mit',
  logout: 'Ausloggen',
  index: 'Heim',
  info: 'Nachrichtenübermittlung',
  Register: 'Melden Sie sich an',
  seeAll: 'Alle ansehen',
  signin: 'Anmeldung',
  marketClosed: 'Laden geschlossen',
  subscriptSucceed: 'Abonnementerfolg',
  aboutUs: 'Über uns',
  insuranceFund: 'Versicherungsfonds',
  'fund-hint-1': 'Die Plattform investiert 5 % ihres Umsatzes in diesen Fonds.',
  'fund-hint-2': 'Wenn eine der von der Plattform unterzeichneten NFT-Serien 30 Tage lang keine Transaktionen aufweist, kauft die Plattform sie zurück und vernichtet sie in der Kette, um die Auswirkungen von Blasen auf den Markt zu verringern.',
  buy_remind_title: 'Herzlichen Glückwunsch, der Kauf war erfolgreich!',
  buy_remind_content: 'Bitte gehen Sie zu Ihrer Sammlung und listen Sie den NFT auf.',
  gotoPost: 'Gehen Sie zu NFT sammeln und auflisten',

  // Common
  confirm: 'Bestätigen',
  cancel: 'Stornieren',
  delete: 'Löschen',
  upload: 'Hochladen',
  save: 'Speichern',
  send: 'Schicken',
  get: 'Erhalten',
  getAgain: 'Holen Sie sich noch einmal',
  verify: 'Verifizieren',
  resend: 'Erneut senden',
  valid: 'Verifizieren',
  noMoreThan10M: 'Die Größe der Upload-Datei darf 10 MB nicht überschreiten',
  success: 'Erfolg!',
  require: 'Erforderlich',
  usdt: 'USDT',
  valid_time: 'Gültige Zeit',
  attention: 'Vorsicht',
  tranfor_hint: 'Übertragene Gegenstände können nicht zum Handel zurück auf den Markt gebracht werden. Bitte bestätigen Sie, ob die Übertragung fortgesetzt werden soll.',

  // rule
  rule_void: 'Darf nicht leer sein',
  rule_email: 'Falsches E-Mail-Format',
  rule_confirmPW: 'Passwörter stimmen nicht überein',
  rule_finish: 'Füllen sie das Formular aus',
  rule_click_valid: 'Drücken Sie die Bestätigungstaste',
  rule_mail_valid: 'Unvollständige E-Mail-Bestätigung',
  rule_payMethod: 'Zahlungsart auswählen',
  rule_mail_code: 'Bestätigungscode eingeben',
  rule_account: 'Kontoinformationen müssen aus Buchstaben und Zahlen bestehen',
  rule_emoji: 'Emojis sind ungültig',
  rule_number: 'Muss eine Nummer sein',
  rule_withdrawal: 'Auszahlung nicht überschreiten',
  rule_length: 'Maximale Länge: 30',
  completeList: 'Vollendet',

  // index
  bestSeller: 'Bestseller',
  transcationAmount: 'Verkäufe',
  lastDayAmount: 'Bd',
  video: 'Video',
  create: 'Minze',
  'index-sell': 'Verkaufen',
  Last_24_hours: 'Letzte 24 Stunden',
  browseCaregory: 'Nach Kategorie durchsuchen',
  vol: 'Gehandeltes Volumen',
  last24h: '24 Stunden',
  'index-fee': 'Kosten',
  'updated-3-min': 'Letzte Aktualisierung: vor 3 Minuten',
  trading: 'Handel',
  'trending-NFTs': 'Trendige NFTs',
  viewAll: 'Alle ansehen',
  startEarning: 'Anfangen zu verdienen',
  'index-product-text-1': 'Handeln Sie täglich mit NFT und erzielen Sie mehr Gewinn',
  'index-product-text-2': 'Laden Sie Ihre Freunde auf diese epische NFT-Reise ein.',

  // setting
  setting_addr: 'Adresse',
  setting_mail: 'Email',
  setting_mailValid: 'E-Mail-Verifizierung',

  // collection
  income: 'Einkommen',
  referralCode: 'Referenzcode',
  paymentSetting: 'Einstellungen',
  userInfo: 'Benutzereinstellungen',
  collection: 'Sammlung',
  transfer: 'Überweisen',
  postSale: 'Verkaufen',
  onSale: 'Zu verkaufen',
  disabled: 'Nicht verfügbar',
  check: 'Bestätigen',
  pointBalance: 'Punktestand',
  price: 'Preis',
  address: 'Adresse',
  splitProduct: 'Bruchteil des Artikels',
  splitInto: 'Fraktionieren von',
  transferCheck: 'Übertragungsbestätigung',
  withdrawInfo: 'Übertragene Gegenstände können nicht zum Handel zurück auf den Markt gebracht werden. Bitte bestätigen Sie, ob die Übertragung fortgesetzt werden soll.',
  sell: 'Verkaufen',
  bind: 'Binden',
  bound: 'Gebunden',
  unBound: 'Nicht gebunden',
  payProcessingFees: 'Servicegebühr',
  payProcessing: 'Stückpreis',
  'birthday-placeholder': 'Geben Sie Ihren Geburtstag ein',
  applyGoogle: 'Beantragen Sie die Google-Verifizierung',
  scanGoogle: 'Verwenden Sie zum Scannen die Google Authenticator-App',
  'finish-phoneValid': 'Vollständige mobile Verifizierung',
  chooseSplit: 'Wählen Sie die Fraktionierung',
  yes: 'Ja',
  no: 'NEIN',
  referralRewards: 'Empfehlungsprämien',
  referralQRcode: 'Referenzcode',
  click_pop: 'Für Einzelheiten anklicken',
  Done: 'Vollendet',
  referralLink: 'Einladungslink',
  reward_total: 'Gesamte Belohnung',
  reward_total_member: 'Anzahl der Empfehlungen',
  reward_all: 'Aktuelle Belohnungen',
  reward_share: 'Belohnungsabteilung',
  reward_member: 'Anzahl der Empfehlungen',
  total: 'Gesamt',
  shareRecored: 'Geschichte teilen',
  share_error: 'Das Teilen ist fehlgeschlagen',
  Mint: 'Minze',
  DailyMission: 'Mission',
  Achievement: 'Leistung',
  Collected: 'Sammlung',
  Details: 'Einzelheiten',
  status_SELLING: 'Auflistung',
  status_DISABLE: 'Übertragen',
  status_PENDING: 'Gesammelt',
  status_AUDITING: 'Verifizieren',
  tab_reserve: 'Heutige Reservierung',
  tab_selling: 'Auflistung',
  tab_unsell: 'Gesammelt',
  Split: 'Bruchteil',
  split_error: 'Die Fraktionierung ist fehlgeschlagen',
  split_hint: 'Nach der Fraktionierung darf der Betrag des einzelnen NFT nicht weniger als {amount} USDT betragen',
  'date-placeholder': 'Wählen Sie das Start-Enddatum aus',
  tradeNum: 'Gehandeltes Volumen',
  colAmount: 'Werke im Besitz',
  purchasePeo: 'Anzahl der Einkäufe',
  share: 'Aktie',
  splitNum: 'Anzahl der Bruchteile',
  itemName: 'Name',
  DATE: 'Zeit',
  PRICE: 'Preis',
  resalePrice: 'Wiederverkaufspreis',
  split_pay_hint: 'Tippen Sie auf die Zahlung, um Ihr USDT an den Verkäufer weiterzuleiten',
  mail_valid_code: 'E-Mail-Code',
  phone_country_required: 'Wählen Sie die mobile Vorwahl',
  edit: 'Bearbeiten',
  check_pay: 'Bestätige Zahlung',
  PrimateSocialSociety: 'Soziale Gesellschaft der Primaten',
  listItemforSale: 'Verkaufen',
  shareCenterTitle: 'Laden Sie Ihre Freunde ein und verdienen Sie gemeinsam',
  shareCenterSubTitle: 'Sie können mit jedem Trade einen zusätzlichen Gewinn erzielen.',
  teamIncome: 'Ihre gesamten Belohnungen',
  '24HourNo1': '1. Platz in 24 Stunden',
  makeAppointmentToday: 'Heutige Reservierung',
  onShelf: 'Auflistung',
  notListed: 'Nicht gelistet',
  chooseNetwork: 'Wählen Sie Kette',
  depositNFT: 'NFT einzahlen',
  supportNetwork: 'Unterstützt derzeit Polygon',
  Next: 'Nächste',
  QRCodeDepositNFT: 'NFT einzahlen',
  'Polygon-text': 'Es werden nur NFTs von TreasureNFT unterstützt.',
  'Polygon-address': 'Polygon-Einzahlungsadresse',
  listingFailed: 'Auflistung fehlgeschlagen',
  availableTime: 'Verfügbare Angebotszeit',
  paymentFail: 'Bezahlung fehlgeschlagen',

  // collection > paymentSetting
  'USDT20-placeholder': 'Geben Sie die TRC20-Adresse ein',
  'USDT(BSC)-placeholder': 'Geben Sie die BSC-Adresse ein',
  'NFT Transfer(Polygon)': 'NFT-Übertragung (Polygon)',
  'NFT Transfer(Polygon)-placeholder': 'Geben Sie die Polygon-Adresse ein',

  // collection > mint
  mintNFT: 'Mint-NFT',
  imageSupport: 'Es werden nur die Bildformate PNG, JPG und GIF unterstützt',
  'name-placeholder': 'Geben Sie den Nachnamen ein',
  'name2-placeholder': 'Geben Sie Vornamen ein',
  mintAmount: 'Menge',
  'mintAmount-placeholder': 'Menge eingeben',
  sellDate: 'Verkaufsdatum',
  'sellDate-placeholder': 'Bitte geben Sie Ihr Verkaufsdatum ein',
  royaltyAccount: 'Lizenzkonto',
  'royaltyAccount-placeholder': 'Bitte geben Sie Ihr Tantiemenkonto ein',
  royalty: 'Königtum',
  'uploadImg-required': 'Es muss ein Bild hochgeladen werden',
  'sellDate-cant-less-than-today': 'Das Verkaufsdatum darf nicht früher als heute liegen',
  'temp-cant-use': 'Vorübergehend nicht erreichbar',
  'mint-cant-info': 'Um ein besseres Benutzererlebnis zu gewährleisten, wird die NFT-Minting-Funktion derzeit stapelweise getestet. Derzeit können nur ausgewählte Benutzer teilnehmen.',
  'name-duplicate': 'Name wiederholt',

  // collection > achievement
  achievement: 'Leistung',
  acv_mission: 'Missionserfolg',
  acv_medal: 'Leistungsmedaille',
  acv_point: 'Punkte',
  tab_daily: 'Mission',
  tab_mission: 'Missionserfolg',
  tab_medal: 'Leistungsmedaille',
  exp_remind_title: 'Ungültiges Erfahrungskonto',
  exp_remind_content: 'Bitte registrieren Sie sich für alle Funktionen.',
  gotoRegister: 'Melden Sie sich an',

  // achievement > 每日任務
  dly_t_DlySignIn: 'Einchecken',
  dly_c_DlySignIn: 'Täglicher Check-in',
  dly_t_DlyRsvScs: 'Reservierung erfolgreich',
  dly_c_DlyRsvScs: 'Täglich erfolgreiche Reservierung',
  dly_t_DlyBuyScs: 'Erfolgreich gekauft',
  dly_c_DlyBuyScs: 'Täglich erfolgreicher Kauf',
  dly_t_DlySlfBuyAmt: 'Täglicher Vollkauf',
  dly_c_DlySlfBuyAmt: 'Täglicher voller Kaufbetrag 500 USDT',
  dly_t_DlyTeamBuyFreq: 'Anzahl der Teamkäufe',
  dly_c_DlyTeamBuyFreq: 'Team 10 Mal gekauft',
  dly_t_DlyTeamBuyAmt: 'Team-Kaufbetrag',
  dly_c_DlyTeamBuyAmt: 'Team-Vollkaufbetrag 2000 USDT',
  dly_t_DlyInvClsA: 'Gültige Empfehlungen der Klasse A',
  dly_c_DlyInvClsA: 'Gültige Note A-Referenz: 1',
  dly_t_DlyInvClsBC: 'Gültige Empfehlungen der Grade B oder C',
  dly_c_DlyInvClsBC: 'Gültige Note B oder C empfohlen: 2',
  dly_t_DlyShr: 'Tägliches Teilen',
  dly_c_DlyShr: '1',

  // achievement > 成就任務
  mis_t_AchSignIn: 'Kumulierter Check-in',
  mis_c_AchSignIn: 'Kumulierter Check-in {num} Tag',
  mis_t_AchContSignIn: 'Kumulierter aufeinanderfolgender Check-in',
  mis_c_AchContSignIn: 'Kumulierter aufeinanderfolgender Check-in-Tag {num}',
  mis_t_AchRsvScs: 'Kumulierte Reservierung',
  mis_c_AchRsvScs: 'Kumulierte Reservierung {num} Mal',
  mis_t_AchBuyScs: 'Kumulierter Kauf',
  mis_c_AchBuyScs: 'Kumulierter Kauf {num} Mal',
  mis_t_AchSlfBuyAmt: 'Kumulierter voller Kaufbetrag',
  mis_c_AchSlfBuyAmt: 'Kumulierter voller Kaufbetrag {num} U',
  mis_t_AchTeamBuyFreq: 'Kumulierte Nr. des Teamkaufs',
  mis_c_AchTeamBuyFreq: 'Kumulierte Nr. des Teamkaufs {num} Mal',
  mis_t_AchTeamBuyAmt: 'Kumulierter Betrag des Teamkaufs',
  mis_c_AchTeamBuyAmt: 'Kumulierte Menge an Team-Vollkauf {num} u',
  mis_t_AchInvClsA: 'Kumulierte gültige Empfehlungen der Klasse A',
  mis_c_AchInvClsA: 'Gültige Personen der Klasse A haben {num} Personen geworben',
  mis_t_AchInvClsBC: 'Gültige Empfehlungen der Grade B oder C',
  mis_c_AchInvClsBC: 'Gültige Personen der Klasse B oder C haben {num} Personen geworben',

  // achievement > 成就勳章
  md_t_AchBuyScs: 'Kumulierter Kauf',
  md_t_AchContSignIn: 'Kumulierter aufeinanderfolgender Check-in',
  md_t_AchInvClsA: 'Kumulierte gültige Empfehlungen der Klasse A',
  md_t_AchInvClsBC: 'Kumulierte gültige Empfehlungen der Grade B oder C',
  md_t_AchRsvScs: 'Kumulierte Reservierung',
  md_t_AchSignIn: 'Kumulierter Check-in',
  md_t_AchSlfBuyAmt: 'Kumulierter voller Kaufbetrag',
  md_t_AchTeamBuyAmt: 'Kumulierter Betrag des Teamkaufs',
  md_t_AchTeamBuyFreq: 'Kumulierte Anzahl der Teamkäufe',

  // collection > level
  lv_point: 'Punkte',
  levelUp: 'Aktualisierung',
  currentRight: 'Mein Privileg',
  dialy_record_num: 'Tägliche Anzahl der reservierten Instanzen',
  reserve_pro_range: 'Preisspanne der reservierten Artikel',
  dialy_reserve: 'Tägliche Anzahl an Tickets',
  trade_luk: 'Glück',
  bonus: 'Bonus',
  level: 'Ebene',
  open_A_lv: 'Gültige Empfehlungen der Klasse A',
  open_BC_lv: 'Gültige Empfehlungen der Klassen B+C',
  reach_level_hint: 'Verbessere Level {level}, um {bonus}({ratio}%) zu erhalten！',
  Completed: 'Vollendet',
  tradecount: 'Anzahl der Trades',
  lv_remind_title: 'Level verbessert! Glückwunsch!',
  lv_remind_content: 'Komplette Funktionen sind jetzt freigeschaltet.',
  gotoUse: 'Weitermachen',

  // collection > mission
  acceptReward: 'Beanspruchen',
  acceptedReward: 'Behauptet',
  mis_goal: 'Ziel',
  mis_award: 'Belohnung',
  mis_type_DAY: 'Tage)',
  mis_type_TIMES: 'Mal',
  mis_type_AMT: 'U',
  mis_type_PEOPLE: 'Menschen',
  mis_goto: 'Nach vorne',

  // achievement > collection > DetailShareModal
  myEarnings: 'mein Einkommen',

  // userCenter
  userInfoDetail: 'Persönliche Angaben',
  levelDetail: 'Level-Informationen',
  select_date: 'Datum auswählen',
  myTeam: 'Mein Team',
  validInvites: 'Gültige Mitglieder',
  ALevel: 'Ein Enthusiast',
  BCLevel: 'B+C-Enthusiasten',
  teamMember: 'Community-Enthusiasten',
  teamContribution: 'Gemeinschaftsbeiträge',
  teamOrder: 'Gemeinschaftsbefehle',
  'referral-code': 'Verweisung',
  'reservation-product-amount': 'Produktmenge',
  preOrderCoupon: 'Gutschein reservieren',
  luckyValue: 'Glück',
  'uc-fee': 'Gebühren',
  myOrder: 'Meine Bestellungen',
  seeOrder: 'Bestellungen prüfen',
  ord_all: 'Aufträge',
  ord_pro: 'wird bearbeitet',
  ord_bought: 'Gekauft',
  ord_sold: 'Verkauft',
  usualFun: 'Gemeinsame Funktionen',
  uc_shareCenter: 'Teilen',
  uc_contact: 'Service',
  uc_novice: 'Tutorials',
  uc_setting: 'Einstellungen',
  uc_myNFT: 'NFTs',
  uc_balDetail: 'Einzelheiten',
  uc_recharge: 'Kaution',
  uc_withdraw: 'Zurückziehen',
  shareInviteCode: 'Aktie',
  totalIncome: 'Alle Einnahmen',
  apply_withdraw: 'Zurückziehen',
  uc_msg_comingSoon: 'Demnächst',

  // userCenter > pointRecord
  date_today: 'Heute',
  date_ystday: 'Gestern',
  date_week: 'Woche',
  date_month: 'Monat',
  pt_DAILY: 'Mission',
  pt_ACHIEVEMENT: 'Missionserfolg',
  pt_LEVEL_UP_SUBTRACT: 'Aktualisierung',

  // creator
  creator: 'Schöpfer',
  topCreator: 'Beliebte Sammlung',
  seeMore: 'Expandieren',
  seeLess: 'Minimieren',
  items: 'Artikel',
  owners: 'Eigentümer',
  floorPrice: 'Mindestpreis',
  tradeVol: 'Gehandeltes Volumen',
  intro: 'Einführung',
  'select-placeholder': 'Geben Sie einen Namen ein, um zu suchen',
  'filter-sort-placeholder': 'Filtern/Sortieren',
  time: 'Zeit',

  // exploreDetail
  auctionIn: 'Countdown',
  auctionOn: 'Im Angebot',
  auctionOnSale: 'Im Angebot',
  countdown: 'Countdown',
  owner: 'Eigentümer',
  reserveCountPiece: 'NFTs',
  amountRangeNFT: 'Reservierungsbereich',

  // payment
  setting: 'Zahlung',
  beginOn: 'Zeit verkaufen',
  resaleIncome: 'Weiterverkaufsgewinn',
  to: 'Zu',
  ownerName: 'Eigentümer',
  historicalVal: 'Historischer Wert',

  // notification
  noNotice: 'Keine neue Nachrichten',
  item: 'Artikel',
  buyer: 'Käufer',
  seller: 'Verkäufer',
  orderNo: 'Best.-Nr.',
  buyPrice: 'Kaufpreis',
  sellPrice: 'Verkaufspreis',
  payType: 'Münze',
  amount: 'Menge',
  copyReservation: 'Reservierung für NFT',
  singleAppointment: 'Einzelreservierung',
  reservationAmount: 'Geschätzter Betrag',
  numberAppointments: 'Geschätzte Nr.',
  numberWinningBids: 'Anzahl der Siege',
  theAmountGoods: 'Stückpreis',
  'notification-SUCCESS': 'Gewonnen',
  'notification-PENDING': 'Öffnung',
  'notification-FAIL': 'Fehlgeschlagen',
  officialSite_title: 'Offizielle Domain von Treasure: https://treasurenft.xyz',
  transferOut: 'NFT übertragen',
  activity: 'Event-Belohnung',
  antiCommission: 'Kommission',
  SELLING_FEE: 'Börsenzulassungsgebühr',
  'recharge-SUCCESS': 'Vollendet',
  'recharge-FAIL': 'Fehlgeschlagen',
  'recharge-PENDING': 'wird bearbeitet',
  myReward: 'Meine Empfehlungsprämien',
  tradingCycle: 'Handelszeitraum',
  promotionReward: 'Empfehlungsprämien',
  promotionIncome: 'Empfehlungseinnahmen',
  myTradingResults: 'Meine Tradings',
  'profit-loss-ratio': 'Gewinn- und Verlustquote',
  'accumulated-profit-loss': 'Gesamtumsatz',
  day: 'Tag',
  reservationFee: 'Reservierungskaution',
  'notification-THROW': 'Verzichten',

  // usdt details
  'usdt-type-SELLING_FEE': 'Swap-Gebühr',
  'usdt-type-SELL_ITEM': 'Verkauft',
  'usdt-type-BUY_ITEM': 'Gekauft',
  serviceFee: 'Swap-Gebühr',
  deposit: 'Kaution',
  withdraw: 'Zurückziehen',
  from: 'aus',
  'usdt-success': 'Gewonnen',
  'usdt-pending': 'Öffnung',
  'usdt-fail': 'Fehlgeschlagen',
  'usdt-amount': 'Menge',
  depositUsdt: 'Zahlen Sie USDT ein',
  withdrawUsdt: 'USDT abheben',
  usdtBalance: 'USDT-Guthaben',
  networkFee: 'Internetgebühr',
  getMail: 'Erhalten',
  verifyMail: 'Verifizieren',
  otherAddress: 'Andere Adressen',
  otherUser: 'Andere Benutzer',
  nihility: 'Keiner',
  errorMinAmount: '{amount} USDT ist Ihre Mindestauszahlung.',
  errorDayLimit: 'Unzureichendes Guthaben für eine 24-Stunden-Auszahlung',
  checkAddressHint: 'Wenn die falsche Adresse eingegeben wurde und die USDT wird an die falsche Adresse übertragen. Benutzer bleiben für etwaige Transaktionsfehler verantwortlich.',
  'rechargeUSDT-BSC': 'Einzahlung USDT (BSC)',
  'rechargeUSDT-TRON': 'Einzahlung USDT (TRC-20)',
  'rechargeUSDT-MANUAL': 'Zahlen Sie USDT ein',
  ACTIVITY_AWARD: 'Aktivitätsbelohnungen',
  'depositUSDT-BSC': 'USDT (BSC) abheben',
  'depositUSDT-TRON': 'USDT (TRC-20) abheben',
  'depositUSDT-TRANSFER': 'USDT abheben (Überweisung)',
  chainTransfer: 'Kettenübertragung',
  innerTransfer: 'Interner Transfer',
  getAddress: 'Adresse zurückziehen',
  getAccount: 'Konto abheben',
  canWithdrawFee: 'Verfügbares Guthaben',
  minAmount: 'Mindestauszahlung',
  dayLimit: '24-Stunden-Limit',
  withdrawFee: 'Servicegebühr',
  canWithdraw: 'Verfügbar',
  network: 'Kette',
  timeZone: 'Zeitzone',
  receiveAll: 'Alle zurückziehen',
  inviteReward: 'Direkte Empfehlungsprämien',
  inviteReward_indirect: 'Indirekte Empfehlungsprämien',
  extractionPoint: 'Zurückziehen',
  rechargePoint: 'Kaution',
  rechargeUSDT: 'Zahlen Sie USDT ein',
  rechargeUaddr: 'USDT-Einzahlungsadresse',
  depositUSDTAddress: 'USDT-Einzahlungsadresse',
  'recharge-hint-1': 'Diese Adresse wird nur USDT unterstützt.',
  'recharge-hint-2': 'NFT wird nicht unterstützt',
  chain: 'Kette',
  extraction: 'Zurückziehen',
  recharge: 'Kaution',
  historyLog: 'Geschichte',
  point: 'Punkte',
  quantity: 'Menge',
  'quantity-placeholder': 'Auszahlungsbetrag eingeben',
  exchangeRate: 'Rate',
  fee: 'Servicegebühr',
  serviveFee: 'Servicegebühr',
  creatorFee: 'Königtum',
  fees: 'Gebühren',
  'emailValid-placeholder': 'Geben Sie Ihren E-Mail-Bestätigungscode ein',
  'googleValid-placeholder': 'Geben Sie Ihren mobilen Bestätigungscode ein',
  'phoneValid-placeholder': 'Geben Sie Ihren Google-Bestätigungscode ein',
  'confirm-address': 'Geben Sie Ihre Wallet-Adresse ein',
  sorry: 'Entschuldigung',
  withdrawAddress: 'Adresse (TRC20)',
  'confirm-address-hint': '„Wenn die falsche Adresse eingegeben wurde und die USDT wird an die falsche Adresse übertragen, Benutzer bleiben für etwaige Transaktionsfehler verantwortlich.“',
  'withdraw-sorry-hint-1': 'Sie haben den Mindestauszahlungsbetrag nicht erreicht.',
  'withdraw-sorry-hint-2': 'USDT ist Ihre Mindestauszahlung.',
  status: 'Bestellstatus',
  'point-PENDING': 'wird bearbeitet',
  'point-SUCCESS': 'Vollendet',
  'point-FAIL': 'Fehlgeschlagen',
  activitiesPoint: 'Belohnungspunkte',
  activitiesUSDT: 'Event-Belohnung',
  agentSharePoint: 'Partnerkommission',
  withdrawCurrent: 'Auszahlung Kryptowährung',
  'select-withdrawCurrent': 'Wählen Sie Auszahlungs-Kryptowährung',
  exp_finish_title: 'Erfahrung beendet',
  exp_finish_content_1: 'Ihr Erlebniskonto wurde beendet',
  exp_finish_content_2: 'Bitte erstellen Sie ein offizielles Konto und erhalten Sie Ihre Erlebnisprämien',
  gotoExtract: 'Zurückziehen',
  rechargeNetwork: 'Einzahlungskette',
  saveQrcode: 'QR-Code speichern',
  'minimum-rechargeAmount': 'Mindesteinzahlung',
  'minimum-rechargeAmount-start': '*Sie können nur einzahlen,',
  'minimum-rechargeAmount-end': 'an diese Adresse. Andere Vermögenswerte können nicht wiederhergestellt werden.',

  // TeamHistory
  totalTeamFlow: 'Gesamttransaktionsvolumen des Teams',
  teamHistory: 'Gesamtes Team-Transaktionsvolumen',
  comsumption: 'Gesamtes Team-Transaktionsvolumen',
  groupCommission: 'Gesamtzahl der Direktempfehlungsprämien',
  CommissionReceived: 'Gesamte Partnerprovision',
  actualProfit: 'Verbleibende Partnerprovision',
  indirectReward: 'Insgesamt indirekte Empfehlungsprämien',
  price_upper: 'Preis',
  time_upper: 'Zeit',
  list: 'Aufführen',
  award: 'Direkte Empfehlungsprämien',
  type: 'Typ',
  type_BUY: 'Kaufen',
  type_SELL: 'Verkaufen',
  type_costPOINT: 'Kosten',
  type_getPOINT: 'Erwerben',
  additionalRewards: 'Zusätzliche Belohnungen',
  tree: 'Agentenbaum',
  NewMembers: 'Neue Mitglieder',
  AllMembers: 'Alle Mitglieder',
  statisticalTeamDailyFlow: 'Tägliches Transaktionsvolumen des Teams',
  allRegisteredMembers: 'Gesamtzahl der registrierten Mitglieder',
  allValidMembers: 'Insgesamt gültiges Mitglied',
  direct: 'Mitglied A',
  activeDirect: 'Gültiges A',
  indirect: 'Mitglied B',
  activeIndirect: 'Gültig B',
  third: 'Mitglied C',
  activeThird: 'Gültiges C',
  statisticsAllDirectPushMembers: 'Gesamtzahl der direkten Empfehlungen',
  statisticsAllDirectAffiliates: 'Gesamtzahl der indirekten Empfehlungen',
  statisticsNewRegisteredMembers: 'Gesamtzahl der neu registrierten Mitglieder',
  statisticsNewActiveMembers: 'Insgesamt neues gültiges Mitglied',
  statisticsNewDirectPushMembers: 'Gesamtzahl der neuen Direktempfehlungen',
  statisticsDirectAffiliates: 'Gesamtzahl der neuen indirekten Empfehlungen',
  numberDirectPushTransactionsOnTheDay: 'Aktuelle Anzahl direkter Empfehlungen',
  teamFlowTheDay: 'Aktuelles Team-Transaktionsvolumen',
  directFlowOfTheDay: 'Aktuelles Transaktionsvolumen für Direktempfehlungen',
  numberTransactionsPushedDuringTheDay: 'Aktuelle Anzahl indirekter Empfehlungen',
  pushWaterDuringTheDay: 'Aktuelle indirekte Transaktion',
  sold: 'Verkauft',
  goldStorageTank: 'Sparschwein',
  NFTs: 'NFTs',
  eRCNFT: 'ERC NFT',
  polygonNFT: 'Polygon-NFT',
  bSCNFT: 'BSC NFT',
  art: 'Kunst',
  collectibles: 'Sammlerstücke',
  domainNames: 'Domain Namen',
  music: 'Musik',
  photography: 'Fotografie',
  sports: 'Sport',
  tradingCards: 'Sammelkarten',
  utility: 'Dienstprogramm',

  // TeamDetail
  teamDetail: 'Teamdetails',

  // List
  newMember: 'Gesamtzahl der neu registrierten Mitglieder',
  consumedMember: 'Insgesamt neues gültiges Mitglied',
  AllMember: 'Gesamtzahl der registrierten Mitglieder',
  Allmemeber_C: 'Insgesamt gültiges Mitglied',
  consumptionDaily: 'Tägliches Transaktionsvolumen des Teams',
  phone_simple: 'Mobil-Nr.',
  invite: 'Einladen',
  value: 'Haltepreis',
  tradingVol: 'Volumen',
  members: '{Name}s',
  memberCollection: 'Persönliche Sammlung',
  memberInvitation: 'Einladungsliste',
  noData: 'Keine Information',
  groupHistoryList: 'Gruppenhandelsliste',
  uc_myAccount: 'Mein Konto',

  // Defi
  'wallet-balance': 'Wallet-Guthaben',
  'wallet-withdraw': 'Sparschwein-Guthaben',
  reserveCount: 'Reservierungsticketbetrag',
  match: 'Reservierung erstellen',
  'reserve-count': 'Geschätzte Nr.',
  reserve: 'Reservieren',
  noviceArea: 'Anfängerbereich',
  'reserve-success': 'Reservierung erfolgreich',
  'reserve-failed': 'Reservierung fehlgeschlagen',
  'reserve-failed-level': 'Mitgliedschaftsstufe nicht qualifiziert',
  'reserve-TimeOut': 'Leider können derzeit keine Reservierungen vorgenommen werden.',
  'reserve-not-available': 'Kann nicht reserviert werden',
  'reserve-success-text': 'Bitte stellen Sie sicher, dass Ihr Guthaben für diesen Kauf ausreicht, andernfalls wird der Kauf nicht durchgeführt.',
  'reserve-APP_0014': 'Dieses Exemplar ist nicht vorrätig',
  'reserve-APP_0005': 'Dieses NFT ist in Ihrem Land nicht verfügbar. Bitte wählen Sie einen anderen NFT.',
  'reserve-APP_0041': 'Du bist derzeit auf Level {level}\n. Du musst Level {needLevel} upgraden, um dies zu kaufen. Bitte arbeiten Sie hart daran, ein Upgrade durchzuführen, um es zu erhalten.',
  'reserve-APP_0043': 'Das tägliche Reservierungslimit wurde erreicht.',
  goLevelUp: 'Gehen Sie zur Missionsliste',
  matching: 'Prüfe die Reihenfolge',
  custom: 'Brauch',
  under: 'Unten',
  availableBalance: 'Restbetrag für Reservierung',

  // 個人中心 > 個人詳細
  assets: 'Vermögenswerte',
  totalAccountEarnings: 'Gesamteinnahmen',
  extracted: 'Zurückgezogen',
  notExtracted: 'Nicht gezeichnet',
  withdraw2: 'Zurückziehen',
  myPrivilege: 'Mein Privileg',
  levelDetails: 'Level-Informationen',
  myInvitation: 'Lädt ein',
  teamDetails: 'Einzelheiten',
  teamRewards: 'Community-Belohnungen',
  totalNumberValidInvites: 'Gültige Mitglieder',
  invitationToALevelValid: 'Gültige A-Empfehlungen (Rabatt {directRecommend}%)',
  'invitationB+CLevelValid': 'Gültige B- und C-Empfehlungen (Rabatt {secondRecommend} % und {thirdRecommend} %)',

  // 個人中心 > 我的收益
  totalRevenue: 'Gesamteinnahmen',
  all: 'Alle',
  mine: 'Mein',
  today: 'Heute',
  yesterday: 'Gestern',
  thisWeek: 'Woche',
  thisMonth: 'Monat',
  personalSettings: 'Persönliche Einstellungen',
  personalDetails: 'Persönliche Angaben',
  yourLevelNotEnough: 'Ihr Niveau ist nicht qualifiziert',
  pleaseNoviceVillageLevelUp: 'Gehen Sie zur Anfängerzone, um Ihr Level zu verbessern',
  rebate: 'Abzug',

  // 個人中心 > 團隊貢獻
  day7: 'Woche',
  day30: 'Monat',
  totalCommission: 'Alle Rabatte',
  'A-antiCommission': 'Rabatt A',
  'B-antiCommission': 'Rabatt B',
  'C-antiCommission': 'Rabatt C',
  levelMember: 'Mitglied',
  bought: 'Gekauft',

  // placeholder
  'placeholder-account': 'Bitte geben sie einen Benutzernamen ein',
  'placeholder-old-password': 'Bitte geben Sie das alte Passwort ein',
  'placeholder-new-password': 'Bitte geben Sie ein neues Passwort ein',
  'placeholder-password-again': 'Bitte geben Sie Ihr Passwort erneut ein',
  'placeholder-email': 'Bitte geben Sie ihre E-Mail-Adresse ein',
  'placeholder-emailCode': 'E-Mail-Bestätigungscode',
  'placeholder-nickname': 'Bitte geben Sie ihren Spitznamen ein',
  'placeholder-referralCode': 'Bitte geben Sie Ihren Empfehlungscode ein',
  'placeholder-address': 'Bitte Adresse eingeben',
  'placeholder-date': 'Datum auswählen',
  'placeholder-phone': 'Geben Sie die Mobiltelefonnummer ein.',
  'placeholder-select': 'Bitte auswählen',
  'placeholder-verification': 'Bestätigungscode',
  'placeholder-email-address': 'Geben sie ihre E-Mailadresse ein',

  // 錯誤代碼
  NOT_ALLOW_FILE_TYPE: 'Falscher Dateityp',
  noMorePost: 'Heutiges Limit erreicht',
  ES_0001: 'Parameterfehler',
  ES_0002: 'Das Hinzufügen ist fehlgeschlagen',
  ES_0003: 'Die Bearbeitung ist fehlgeschlagen',
  ES_0004: 'Datenfehler',
  ES_0005: 'Upload fehlgeschlagen',
  ES_0006: 'Der hochgeladene Dateityp wird nicht unterstützt.',
  ES_0007: 'Keine Daten gefunden',
  ES_0008: 'Die Dateigröße überschreitet die maximale Grenze.',
  ES_0009: 'Anfragefehler',
  ES_0010: 'SMS hinzufügen fehlgeschlagen',
  ES_0011: 'SMS wiederholt hinzugefügt',
  ES_0012: 'Keine passende SMS',
  ES_0013: 'Keine passende Bestellung',
  ES_0014: 'Mehrere Bestellungen abgleichen',
  ES_0015: 'Maschine nicht gefunden',
  ES_0016: 'SMS wiederholt gesendet',
  ES_0017: 'SMS nicht gefunden',
  ES_0018: 'Kein passender Bestellstatus',
  ES_0019: 'Zeitüberschreitung der Anforderung',
  ES_0020: '#VALUE!',
  G_0000: 'Erfolg',
  G_0001: 'Validierungsfehler',
  G_0002: 'Datenfehler',
  G_0003: 'Anfrage fehlgeschlagen.',
  G_0004: 'URL nicht gefunden',
  G_0101: 'Daten nicht verschlüsselt',
  G_0102: 'Die Datenentschlüsselung ist fehlgeschlagen',
  G_0103: 'IP konnte nicht abgerufen werden',
  G_0104: 'Gefälschte IP',
  G_0105: 'IP auf der schwarzen Liste',
  G_0107: 'Account deaktiviert',
  G_0201: 'Die Token-Überprüfung ist fehlgeschlagen',
  G_0202: 'Redis nicht gefunden',
  G_0400: 'Zugriff verboten',
  G_0401: 'Nicht autorisiert',
  G_0403: 'Zugriff verweigert',
  G_0404: 'Das System ist ausgelastet. Bitte versuchen Sie es später erneut',
  G_0405: 'Systemwartung',
  G_9999: 'Unbekannter Fehler',
  EO_001_1: 'Account existiert nicht',
  EO_001_2: 'Passwort 5 Mal falsch,Die Kontosicherheitssperre wurde automatisch aktiviert.Bitte wenden Sie sich an den Online-Kundendienst, um Hilfe zu erhalten.',
  EO_001_3: 'Bitte bestätigen Sie, dass das Login-Passwort korrekt ist',
  EO_001_4: 'Fehler beim alten Passwort',
  EO_001_5: 'Geschützter Betrieb',
  EO_002_1: 'Bestätigungscode abgelaufen',
  EO_002_2: 'Fehler im Bestätigungscode',
  EO_003_1: 'Google-Authentifikator nicht registriert',
  EO_003_2: 'Google-Verifizierungsfehler',
  EO_003_3: 'Die Google-Bestätigung ist abgelaufen',
  EO_004_1: 'Diese E-Mail wird verwendet.',
  EO_004_2: 'Dieses Handy ist im Einsatz.',
  EO_004_3: 'Dieser Spitzname wird verwendet.',
  EO_004_4: 'Ungültiger Empfehlungscode',
  EO_004_5: 'Benutzername wurde verwendet',
  EO_005_1: 'Bitte bestätigen Sie, ob der Postfach-Bestätigungscode korrekt eingegeben wurde',
  EO_005_2: 'Der E-Mail-Bestätigungscode ist falsch. Bitte geben Sie Ihren Bestätigungscode erneut ein.',
  EO_005_3: 'Der E-Mail-Bestätigungscode ist abgelaufen. Bitte senden Sie erneut einen neuen Bestätigungscode.',
  EO_005_4: 'Die Gültigkeit des Google-Authentifikators ist abgelaufen',
  EO_007_1: 'Mangelhaftes Gleichgewicht',
  EO_007_2: 'Aufgrund der zweistufigen Verifizierung ist eine Auszahlung nach 24 Stunden möglich.',
  EO_007_3: 'Auszahlung über interne Adresse nicht möglich. Bitte verwenden Sie die interne Übertragungsfunktion.',
  EO_007_4: 'Überschreiten Sie das tägliche Auszahlungslimit',
  EO_008_1: 'Wiederholter Artikelname',
  EO_009_1: 'Wiederholte Zahlungsart',
  EO_010_1: 'Wiederholter Systemeinstellungstyp',
  EO_011_1: 'Wiederholter Marktname',
  APP_0001: 'Fehler beim Bestätigungscode',
  APP_0002: 'Schnappen',
  APP_0003: 'NFT-Statusfehler',
  APP_0004: 'Unveröffentlicht',
  APP_0005: 'Artikel konnte nicht gekauft werden',
  APP_0006: 'Zahlungsfehler',
  APP_0007: 'Fehler bei der Bestellrolle',
  APP_0008: 'Fehler beim Bestellstatus',
  APP_0009: 'Der persönlich freigegebene Artikel kann nicht gekauft werden',
  APP_0010: 'Fehler beim Bruchteilbetrag',
  APP_0011: 'Fehler beim Status der Bestellgebühr',
  APP_0012: 'Authentifizierungsfehler',
  APP_0013: 'Mangelhaftes Gleichgewicht',
  APP_0014: 'NFT nicht gefunden',
  APP_0015: 'Markteinstellung nicht gefunden',
  APP_0016: 'Wallet nicht gefunden',
  APP_0017: 'Wallet-Adresse nicht gefunden',
  APP_0018: 'Benutzer nicht gefunden',
  APP_0019: 'Bestellung nicht gefunden',
  APP_0020: 'Bestellgebühr nicht gefunden',
  APP_0021: 'Markt nicht gefunden',
  APP_0022: 'Anzahl der Artikelübertragungsfehler',
  APP_0023: 'Fehler beim Kaufstatus',
  APP_0024: 'Plattformeinstellung nicht gefunden',
  APP_0025: 'Zahlung nicht gefunden',
  APP_0026: 'Fraktionierung',
  APP_0027: 'Agentenauthentifizierung nicht erforderlich',
  APP_0028: 'Markt wiederholt angewendet',
  APP_0029: 'Marktname wiederholt',
  APP_0030: 'Downline-Eintrag nicht gefunden',
  APP_0031: 'Einstellung auf der schwarzen Liste nicht gefunden',
  APP_0035: 'Fehler bei der Wallet-Adresse',
  APP_0036: 'Betrag niedriger als Mindestgrenze',
  APP_0032: 'Aktivität nicht gefunden',
  APP_0033: 'Belohnung existierte',
  APP_0034: 'Aktivität ausstehend',
  APP_0037: 'Das maximale Limit, mit dem ein Konto verknüpft werden kann, wurde überschritten',
  APP_0038: 'Mission nicht gefunden',
  APP_0039: 'Missionsdatensatz nicht gefunden',
  APP_0040: 'Auftrag erledigt',
  APP_0041: 'Geschätzter Betrag falsch',
  APP_0042: 'Kein Mehrwertnachweis',
  APP_0043: 'Reservierungslimit überschritten',
  APP_0044: 'Kette nicht gefunden',
  APP_0045: 'Uneingeschränkte Bedingungen',
  APP_0046: 'Künstler nicht gefunden',
  APP_0047: 'Artikelname wiederholt',
  APP_0048: 'Benutzer nicht in der Whitelist',
  APP_0049: 'NFT-Besitzerfehler',
  APP_0050: 'Der Artikel wird übertragen.',
  APP_0051: 'Fehler bei den Ebeneninformationen',
  APP_0052: 'Tägliches Kauflimit erreicht',
  APP_0058: 'Anzahl der erreichten Trades',
  APP_0061: 'Jede Instanz konnte nur einmal pro Tag reserviert werden.',
  'defi-info-1': 'Für jede Zeitzone stehen zwei Termine pro Tag zur Verfügung.',
  'defi-info-2': 'Terminstatus: nicht gestartet – der Countdown bis zur reservierbaren Zeit läuft bald ab – zeigt den Countdown der verbleibenden Zeit bis zum Ende des Termins an.',
  'defi-info-3': 'Termin für Sitzung 1: Termin: 08:00 – 12:00 Uhr, Terminergebnis: 13:00 Uhr, Handelszeit: 13:30 – 13:35 Uhr',
  'defi-info-4': 'Reservierungszeit für Sitzung 2: Reservierungszeit: 17:00–21:00 Uhr, Reservierungsergebnis: 22:00 Uhr, Handelszeit: 22:30–22:35 Uhr',
  'defi-info-5': 'Sie können nur während des Terminzeitraums an dem Termin teilnehmen und nach Ablauf des Terminzeitraums keinen Termin mehr vereinbaren.',
  'defi-info-6': 'Verfügbares Guthaben: die Anzahl der zum Verkauf angebotenen NFTs + Wallet-Guthaben.',
  'defi-info-7': 'Die Anzahlung für die Reservierung wird je nach Preisspanne Ihrer NFT-Reservierung im Voraus abgezogen. (Einzahlung von niedrig nach hoch: 5, 20, 50, 100, 200, 500 USDT).',
  'defi-info-8': 'Sollte die Reservierung nicht erfolgreich sein, wird die Anzahlung auf das Konto zurückerstattet. Bei erfolgreicher Buchung kann die Anzahlung vom Transaktionsbetrag abgezogen werden. Reicht der Kontostand nicht aus und die Transaktion schlägt fehl, wird die Anzahlung abgezogen. Bitte achten Sie auf einen ausreichenden Kontostand.',
  'defi-info-9': 'Jede Preisklasse ist auf eine Buchung pro Person und Tag beschränkt.',
  'defi-info-10': 'Je höher das Level, desto mehr Termine und Preisspannen können Sie vereinbaren und desto mehr Gewinn können Sie erzielen.',

  // 新增
  SeeLess: 'Weniger anzeigen',
  SeeMore: 'Mehr sehen',
  payMethod: 'Bezahlverfahren',
  status_PAYING: 'Handel in Bearbeitung',
  paymentCompleted: 'Zahlung abgeschlossen',
  'reserve-APP_0065': 'Dieses NFT ist in Ihrem Land nicht verfügbar. Bitte wählen Sie einen anderen NFT.',
  successfulPayment: 'Erfolgreich gelistet',
  reach_level_all_hint: 'Verbessere Level {level}, um alle Belohnungen zu erhalten!',
  reach_level_hint_2: 'Es ist nicht möglich, Level-Belohnungen wiederholt einzufordern.',
  temporarilyUnavailable: 'Vorübergehend nicht erreichbar',
  bscText: 'Um ein besseres Benutzererlebnis zu gewährleisten, befindet sich die NFT-Einzahlungsfunktion in der BSC-Kette derzeit in der Batch-Testphase. An dieser Phase können nur ausgewählte Benutzer teilnehmen.',
  'trade-rules': 'Vorschriften',
  withoutAccount: 'Sie haben kein Konto?',
  OK: 'OK',
  creator_items: 'Artikel',
  'placeholder-gender': 'Wähle Geschlecht',
  transactionHour: 'Handelszeit',
  transactionReward: 'Handelsbelohnung',
  changePassword: 'Kennwort ändern',
  submit: 'Einreichen',
  emailIllustrate: 'Treten Sie unserer Mailingliste bei, um über unsere neuesten Funktionsveröffentlichungen, NFT-Listen sowie Tipps und Tricks für die Navigation auf der Treasure-Webseite auf dem Laufenden zu bleiben.',
  footer_resource: 'Ressourcen',
  footer_docs: 'Dokumente',
  footer_friends: 'Freunde einladen',
  footer_howtoBuy: 'Wie kauft man',
  footer_news: 'Nachricht',
  footer_blog: 'Blog',
  footer_company: 'Unternehmen',
  footer_privacy: 'Datenschutzrichtlinie',
  footer_service: 'Nutzungsbedingungen',
  footer_agreement: 'Nutzungsbedingungen',
  footer_contactUs: 'Kontaktiere uns',
  nextTradeDate: 'Nächste Handelszeit',
  nationality: 'Staatsangehörigkeit',
  Taiwan: 'Taiwan',
  gallery: 'Bibliothek',
  nextAvatar: 'Ändern',
  'directShare-extra': 'Belohnung der Klasse A und zusätzliche Belohnung',
  'indirectShare-extra': 'Belohnung der Klasse B und zusätzliche Belohnung',
  'thirdShare-extra': 'Belohnung der Klasse C und zusätzliche Belohnung',
  classOrder: 'Bestellen Sie {Level}',
  transferNFT: 'NFT übertragen',
  appointment: 'Schon reserviert',
  instructionalVideo: 'Lehrvideo',
  howSignUp: 'So melden Sie sich an',
  howToDeposit: 'So zahlen Sie ein',
  howToBuy: 'Wie kauft man',
  'placeholder-password': 'Bitte geben Sie Ihr Passwort ein',
  pleaseAddress: 'Bitte bestätigen Sie Ihre Adresse',
  choosestyle: 'Wählen Sie Stil',
  style: 'Stil 1',
  quickFill: 'Automatisch ausfüllen',
  howToViewInvitations: 'So überprüfen Sie die Einladung',
  howToWithdraw: 'So ziehen Sie sich zurück',
  howToViewEarnings: 'So überprüfen Sie die Einnahmen',
  Turkey: 'Truthahn',
  Canada: 'Kanada',
  SaudiArabia: 'Saudi-Arabien',
  Jordan: 'Jordanien',
  Spain: 'Spanien',
  Brazil: 'Brasilien',
  Singapore: 'Singapur',
  America: 'Amerika',
  Iran: 'Iran',
  Kuwait: 'Kuwait',
  Philippines: 'Philippinen',
  swipeRight: 'Wische nach rechts',
  APP_0054: 'Reservierungsanomalie, bitte wenden Sie sich an den Kundendienst.',
  EO_004_6: 'Ungültiger Empfehlungscode\n Bitte wenden Sie sich an den Kundendienst.',
  APP_0053: 'Kontoanomalie. Bitte wenden Sie sich an den Kundendienst.',
  EO_001_6: 'Kontoanomalie. Bitte wenden Sie sich an den Kundendienst.',
  'reserve-APP_0054': 'Handel deaktiviert\n Bitte wenden Sie sich an den Kundendienst.',
  pleaseLinkEmail: 'Bitte verlinken Sie Ihre E-Mail',
  aboutJump: 'Umleiten',
  footer_docs_title: 'TreasureNFT',
  footer_friends_title: 'So teilen Sie Einladungen',
  footer_howtoBuy_title: 'Wie man handelt',
  overview: 'Überblick',
  'document-text-1': 'TreasureNFT ist die weltweit erste umfassende NFT-Handelsplattform, die auf algorithmischem Handel basiert. Durch ein innovatives algorithmisches Handelsmodell, das automatische algorithmische Notierungen verwendet, ist die automatische Aufrechterhaltung der Liquidität ein Vorreiter in der Branche, im Gegensatz zum traditionellen Notierungsmodell der NFT-Handelsplattform, das anfällig für Störungen der Marktstimmung sowie irrationale Anlagefaktoren ist, die durch Schwankungen der NFT-Vermögenspreispreise verursacht werden bedeutend. Sobald die Markttemperatur nachlässt, wird es bei NFT-Vermögenswerten an Liquidität mangeln. TreasureNFT mit einem innovativen algorithmischen Preishandelsmodell bringt Liquidität in jedes NFT-Asset.',
  'document-title-2': 'Der weltweit erste integrierte Kryptowährungs-NFT-Marktplatz – TreasureNFT',
  invitation: 'Einladung',
  'invitation-text-1': 'Klicken Sie auf der Kontoseite auf „Empfehlung“, um das Sharing Center aufzurufen.',
  'invitation-text-2': 'Kopieren Sie den Empfehlungscode und den Einladungslink oder klicken Sie auf „Teilen“, um sie direkt über soziale Apps zu teilen. Wie nachfolgend dargestellt:',
  'invite-text-1': 'Klicken Sie auf „Erkunden“ und wählen Sie die entsprechende NFT-Sammlung aus (z. B.: Young Lady)',
  'invite-text-2': 'Wählen Sie Ihre Lieblings-NFTs aus oder kaufen Sie NFTs, indem Sie nach Preis und Zeit filtern.',
  'invite-title-2': 'NFT nach Preisklasse kaufen',
  'invite-text-3': 'Klicken Sie auf „Erkunden“ und wählen Sie die entsprechende NFT-Sammlung aus (z. B.: Young Lady)',
  'invite-text-4': 'Nachdem Sie eine NFT-Reservierung vorgenommen haben, klicken Sie auf „Abholung“, um die reservierten Bestellinformationen anzuzeigen (heutige Reservierung, Auflistung, nicht gelistet).',
  'invite-li-1': 'Heutige Reservierung: Informationen zur Reservierungsbestellung (Abgleich)',
  'invite-li-2': 'Angebot: Ausstehende Bestellung zum Verkauf',
  'invite-li-3': 'Nicht gelistet: NFT-Informationen, die erfolgreich gekauft wurden',
  'invite-text-5': 'Um NFT zu verkaufen, klicken Sie auf „Nicht gelistet“ und wählen Sie „Zum Verkaufen auflisten“.',
  'invite-text-6': 'Klicken Sie auf „Angebot“, um die zum Verkauf stehende Bestellung anzuzeigen',
  tips: 'Tipps',
  'tips-subtitle': 'Beschreibung der Reservierungszeit',
  'tips-li-1': 'Reservierungszeit: 21:00-18:00 (+1 Tag)',
  'tips-li-2': 'Haltbarkeit: 21:00-18:00 (+1 Tag)',
  'tips-li-3': 'Handelszeit: 19:00–19:30 Uhr – Veröffentlichung des Reservierungsergebnisses um 19:00 Uhr.',
  othersCol: 'Sammlung',
  UnitedKingdom: 'Großbritannien',
  'notification-PAYING': 'Erfolg',
  enter: 'Eingeben',
  expEnd_title: 'Deine Sitzung ist abgelaufen',
  expEnd_title_hint: 'Schalten Sie LV1 mit {amount}U frei, um höherwertige NFTs zu reservieren',
  goRecharge: 'Kaution',
  APP_0059: 'Auszahlungslimit für Erfahrungskonto überschritten',
  EO_004_7: 'Ungültiger Empfehlungscode',
  EO_004_8: 'Ungültiger Empfehlungscode',
  APP_0055: 'Unqualifiziertes Niveau',
  APP_0056: 'Statusfehler im Missionsdatensatz',
  APP_0057: 'Fehler beim Experience-Kontostatus',
  APP_0060: 'Dies ist das Erlebniskonto',
  APP_0068: 'Die Adresse wurde verwendet',
  APP_0062: 'Falsche Auflistungszeit',
  APP_0063: 'Die Terminzeit ist: {startTime}-{endTime}. Bitte seien Sie in diesem Zeitraum zu Ihrem Termin anwesend. Danke schön.',
  APP_0064: 'Unzureichender geschätzter Betrag',
  APP_0065: 'Falsche Ländercodes',
  APP_0066: 'Ländercodes nicht gefunden',
  APP_0067: 'Die Gebühr übersteigt den Auszahlungsbetrag',
  APP_0069: 'Die Handelszeit des Anfängerkontos ist abgelaufen',
  bonus_trade: 'Trading-Sparschwein',
  bonus_referral: 'Empfehlungs-Sparschwein',
  bonus_keep_hint: 'Prämien werden {day} Tage einbehalten. Wenn das Upgrade nicht vor dem {Datum} durchgeführt werden konnte, werden alle Prämien zurückgenommen',
  APP_0071: 'Die Auszahlungszeit ist: {startTime}-{endTime}, bitte beantragen Sie die Auszahlung innerhalb dieses Zeitraums, vielen Dank.',
  nftAssets: 'NFT-Asset',
  totalAssets: 'Gesamtvermögen',
  reservenotDrawn: 'Unveröffentlichte Reservierungsaufträge',
  'reservenotDrawn-hint': 'Sie haben noch unveröffentlichte Reservierungsaufträge, bitte bestätigen Sie Ihren Widerruf',
  'reservenotDrawn-hint-post': 'Sie haben noch unveröffentlichte Reservierungsaufträge, verfügbarer Auszahlungsbetrag: {balance} USDT',
  Congo: 'Kongo',
  Egypt: 'Ägypten',
  Chile: 'Chile',
  APP_0070: 'Betriebsfrequenzfehler, bitte versuchen Sie es später erneut.',
  estimatedAmount: 'Geschätzter Betrag',
  estimatedNumber: 'Geschätzte Nr.',
  itemPrice: 'Stückpreis',
  openBlindBox: 'Öffnen Sie die Blindbox',
  status_GIVE: 'Airdrop-Belohnung',
  reach: 'Erreiche LV{Level}',
  buyCount: '{count} Zeit(en) handeln',
  open: 'Offen',
  balanceMadeUp: 'Sie haben das Guthaben aufgeladen.',
  insufficientBalance: 'Das Guthaben reicht nicht aus, um NFT zu kaufen. Bitte füllen Sie das Guthaben auf.',
  'activity-title-text': 'Lucky World Cup NFT-Geschenkpool',
  'activity-countdown': 'Gezeichneter Countdown',
  'activity-time': 'Gezeichnete Zeit',
  prizePool: 'Pool Größe',
  platformPrizePool: 'Plattformpool',
  'prizePool-reservation': 'Gewinnreservierung',
  'prizePool-qualify': 'Reservierungsqualifikation',
  'start-booking-prize': 'Start-Reservepreis',
  winnersList: 'Liste der Gewinner',
  myTicket: 'Meine Tickets',
  lotteryNumber: 'Zeichnungsnummer',
  'bonus-win-1': '1st',
  'bonus-win-2': '2nd',
  'bonus-win-3': '3rd',
  itemValue: 'Wert',
  awardMoney: 'Belohnen',
  'world-cups-event': 'Zeitlich begrenzte Veranstaltungen der Weltmeisterschaft',
  limitedNFT: 'Begrenztes NFT',
  bonusPool: 'Belohnungspool',
  'activity-info-1': 'Für die Reservierung der Veranstaltung ist eine Gebühr von 100U erforderlich',
  'activity-info-2': '80U werden zurückerstattet, wenn Sie den NFT in limitierter Auflage nicht gewinnen',
  'activity-info-3': 'Der Gewinner der Instanz wird gleichzeitig bekannt gegeben',
  'activity-info-4': 'Das Ergebnis der Lotterie wird in der Instanz bekannt gegeben',
  APP_0075: 'Die Reservierung für diese Veranstaltung ist belegt',
  APP_0076: 'Die Einzelreservierung für diese Veranstaltung ist belegt',
  couponValue: 'Ticketwert',
  over: 'Beendet',
  tab_limited: 'Zeitlich begrenztes Event',
  optional: 'Optional',
  tokenId: 'Token-ID',
  automaticHosting: 'Autoverkauf',
  setup: 'Einstellungen',
  depositAddress: 'Einzahlungsadresse',
  footer_intro1: 'TreasureNFT ist eine Web3-Umsatzplattform, die auf NFT-Sammlungen basiert',
  'top-creator': 'TOP-KOLLEKTIONEN ÜBER',
  index_intro1: 'Mit TreasureNFT Einkommen zu erzielen ist einfach: RESERVIEREN Sie einfach und handeln Sie dann, um zu VERDIENEN',
  highestBid: 'Höchstes Gebot',
  'index-h1-1': 'ENTDECKEN UND SAMMLEN SIE DIGITALE KUNST-NFTs',
  'collection-fetured': 'AUSGEWÄHLTE NFT-SAMMLERSTÜCKE',
  'index-subtitle-1': 'Digitaler Marktplatz für Krypto-Sammlerstücke und nicht fungible Token (NFTs). Kaufen, verkaufen und entdecken Sie exklusive digitale Assets.',
  exploreNow: 'Loslegen',
  sunday: 'Sonntag',
  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
  dailyTasks: 'Tägliche Missionsbelohnungen',
  'create-sell-title': 'RESERVIEREN UND VERKAUFEN SIE IHR NFT EINFACH',
  signUp: 'Jetzt registrieren',
  discoverNfts: 'Entdecken Sie weitere NFTs',
  allFilter: 'Alle Filter',
  'index-illustrate-text-1': 'Erkunden, entdecken und verdienen Sie viel mit einem der besten Web3-NFT-Marktplätze der Welt',
  'index-illustrate-text-2': 'Mehrfachbelohnung',
  'index-illustrate-text-3': 'TreasureNFT nutzt ein proprietäres, KI-gestütztes algorithmisches Handelsmodell und bietet einen dualen Ertragsmechanismus mit Handelsprämien und Empfehlungsprämien.',
  'index-illustrate-text-4': 'Verdienen Sie zukünftigen Wert',
  'index-illustrate-text-5': 'TreasureNFT reduziert die Eintrittshürden des NFT-Marktes und erweitert die Grenzen der NFT-Sammlung und des NFT-Handels durch seinen innovativen algorithmischen KI-Handelsprozess und sein lohnendes Finanzmodell.',
  chineseSignature: 'NFTs haben gewonnen',
  myAssets: 'Mein Vermögen',
  invaildEmail: 'Ungültige E-Mail',
  NFTResultTime: 'Reservierungsergebnis',
  swapFee: 'Swap-Gebühr',
  annualROI: 'Wachstumsrate',
  ROI: 'ROI',
  APR: 'APR',
  purchaseHistory: 'Kaufhistorie',
  reservationTime: 'Reservierungszeit',
  contractAddress: 'Vertragsadresse',
  timeLeft: 'Übrige Zeit',
  yourBonus: 'Ihr Bonus',
  year: 'Jahr',
  month: 'Monat',
  continueReservation: 'Weitermachen',
  artistApplicationForm: 'Bewerbungsformular für Künstler',
  illustrate: 'veranschaulichen',
  'South Africa': 'Südafrika',
  'Viet Nam': 'Vietnam',
  Guinea: 'Guinea',
  Kenya: 'Kenia',
  Madagascar: 'Madagaskar',
  Somalia: 'Somalia',
  Sudan: 'Sudan',
  Uganda: 'Uganda',
  Zimbabwe: 'Zimbabwe',
  Afghanistan: 'Afghanistan',
  Bangladesh: 'Bangladesch',
  Bhutan: 'Bhutan',
  Cambodia: 'Kambodscha',
  Indonesia: 'Indonesien',
  Israel: 'Israel',
  Japan: 'Japan',
  Lebanon: 'Libanon',
  Malaysia: 'Malaysia',
  Mongolia: 'Mongolei',
  Myanmar: 'Myanmar',
  Nepal: 'Nepal',
  Russia: 'Russland',
  SriLanka: 'SriLanka',
  Albania: 'Albanien',
  Austria: 'Österreich',
  Belarus: 'Weißrussland',
  Belgium: 'Belgien',
  Bulgaria: 'Bulgarien',
  Croatia: 'Kroatien',
  Czech: 'Tschechisch',
  Denmark: 'Dänemark',
  Finland: 'Finnland',
  France: 'Frankreich',
  Germany: 'Deutschland',
  Greece: 'Griechenland',
  Hungary: 'Ungarn',
  Iceland: 'Island',
  Ireland: 'Irland',
  Italy: 'Italien',
  Lithuania: 'Litauen',
  Luxembourg: 'Luxemburg',
  Monaco: 'Monaco',
  Netherlands: 'Niederlande',
  Norway: 'Norwegen',
  Poland: 'Polen',
  Portugal: 'Portugal',
  Romania: 'Rumänien',
  Serbia: 'Serbien',
  Slovakia: 'Slowakei',
  Slovenia: 'Slowenien',
  Sweden: 'Schweden',
  Switzerland: 'Schweiz',
  Ukraine: 'Ukraine',
  Belize: 'Belize',
  Bermuda: 'Bermuda',
  Cayman: 'Cayman',
  'Costa Rica': 'Costa Rica',
  Cuba: 'Kuba',
  Dominica: 'Dominica',
  Dominican: 'dominikanisch',
  Salvador: 'Salvador',
  Guatemala: 'Guatemala',
  Haiti: 'Haiti',
  Honduras: 'Honduras',
  Jamaica: 'Jamaika',
  Mexico: 'Mexiko',
  Nicaragua: 'Nicaragua',
  Panama: 'Panama',
  'Puerto Rico': 'Puerto Rico',
  Argentina: 'Argentinien',
  Colombia: 'Kolumbien',
  Paraguay: 'Paraguay',
  Uruguay: 'Uruguay',
  Venezuela: 'Venezuela',
  Australia: 'Australien',
  Fiji: 'Fidschi',
  Guam: 'Guam',
  'Marshall Islands': 'Marshallinseln',
  'New Zealand': 'Neuseeland',
  Palau: 'Palau',
  Tonga: 'Tonga',
  Tuvalu: 'Tuvalu',
  Laos: 'Laos',
  Thailand: 'Thailand',
  Brunei: 'Brunei',
  'Timor Timur': 'Timor Timur',
  Morocco: 'Marokko',
  Nigeria: 'Nigeria',
  China: 'China',
  India: 'Indien',
  Kazakh: 'Kasachisch',
  Korea: 'Korea',
  Maldives: 'Malediven',
  Qatar: 'Katar',
  'United Arab Emirates': 'Vereinigte Arabische Emirate',
  Ecuador: 'Ecuador',
  Pakistan: 'Pakistan',
  Yemen: 'Jemen',
  'Polygon-text-2': 'Bei falscher Einzahlung wird Ihr NFT nicht wiederhergestellt.',
  IRR: 'IRR',
  Azerbaijan: 'Aserbaidschan',
  websiteEntry: 'Website-Eingang',
  alternateEntrance: 'Alternativer Eingang',
  'entrance-text-1': 'Aktualisieren Sie die URL in Echtzeit',
  'entrance-text-2': 'Kann nicht geöffnet werden? (Leeren Sie zuerst den Cache) oder wechseln Sie zur Aktualisierung zum Telekommunikationsnetz und versuchen Sie es erneut!',
  'entrance-text-3': 'TreasureMeta Corporation 2022',
  Uzbekistan: 'Usbekistan',
  balanceReservation: 'Restbetrag für Reservierung',
  drawDate: 'Ziehungsdatum',
  appointmentDate: 'Reservierungsdatum',
  EXPERIENCE_ADD: 'Probefonds',
  EXPERIENCE_RECYCLE: 'Rückgewinnung des Testgeldes',
  footer_download: 'Herunterladen',
  selectionPeriod: 'Wählen Sie die Zeit',
  APP_0087: 'Die Terminvereinbarung ist beendet',
  APP_0073: 'Doppelter Vorgang',
  'login-via-wallet': 'Wallet Connect',
  'register-via-wallet': 'Melden Sie sich mit Wallet an',
  linkedWallet: 'So melden Sie sich an: Verbinden Sie Ihr Wallet',
  walletAddress: 'Wallet-Adresse',
  'address-bounded-hint': 'Diese Adresse wurde bereits gebunden',
  'address-unbound-hint': 'Diese Adresse wurde nicht gebunden',
  bindWallet: 'Portemonnaie binden',
  todayReserve: 'Die erste Stufe',
  tomorrowReserve: 'Die zweite Stufe',
  reservation: 'Reservierung',
  appointmentInstructions: 'Innerhalb eines Tages können Sie NFT mehrmals in verschiedenen Sitzungen buchen, um weitere Vorteile zu erhalten.',
  'select-wallet': 'Bitte wählen Sie eine Wallet aus',
  'bind-successfully': 'erfolgreich binden',
  'account-check-modal-hint': 'Haben Sie bereits ein TreasureNFT-Konto?',
  noAccount: 'NEIN',
  comingToEnd: 'Kurz vor dem Start',
  'reward-title': 'Glückwunsch',
  'reward-detail': 'Sie haben die Belohnung von {usdt} erhalten, die Nutzungsdauer beträgt {day} Tage, Sie können die Details im persönlichen Center überprüfen',
  okcText: 'Um ein besseres Benutzererlebnis zu gewährleisten, befindet sich die NFT-Einzahlungsfunktion in der OKC-Kette derzeit in der Batch-Testphase. An dieser Phase können nur ausgewählte Benutzer teilnehmen.',
  'register-country': 'Staatsangehörigkeit',
  'placeholder-register-country': 'Bitte wählen Sie Ihre Nationalität aus.',
  accountNumber: 'Konto',
  Telegram: 'Telegramm',
  airdrop: 'Luftabwurf',
  dailyRewards: 'Reservierungsprämie',
  growthProcess: 'Levelaufstiegsbelohnung',
  soulPath: 'Bonuspool',
  treasurePrizePool: 'Preis Pool',
  reserveCratesInfo: 'Für jede erfolgreich reservierte Sitzung können Sie eine Reservierungsschatzkiste öffnen, in der Sie nur eine Belohnung aus dem Preispool erhalten können. Derzeit gibt es zwei Reservierungssitzungen und die Schatztruhe kann maximal zweimal täglich geöffnet werden.',
  commemorativeBadge: 'Abzeichen',
  randomBadge: 'Zufällig',
  Vietnam: 'Vietnam',
  SouthAfrica: 'Südafrika',
  Georgia: 'Georgia',
  CostaRica: 'Costa Rica',
  PuertoRico: 'PuertoRico',
  MarshallIslands: 'Marshallinseln',
  NewZealand: 'Neuseeland',
  TimorTimur: 'TimorTimur',
  UnitedArabEmirates: 'Vereinigte Arabische Emirate',
  Peru: 'Peru',
  Guyana: 'Guyana',
  Suriname: 'Surinam',
  FrenchGuiana: 'Französisch-Guayana',
  Bolivia: 'Bolivien',
  Liechtenstein: 'Liechtenstein',
  Moldova: 'Moldawien',
  Latvia: 'Lettland',
  Estonia: 'Estland',
  Vatican: 'Vatikan',
  Andorra: 'Andorra',
  RepublicofNorthMacedonia: 'Republik Nordmazedonien',
  SanMarino: 'San Marino',
  Malta: 'Malta',
  BosniaandHerzegovina: 'Bosnien und Herzegowina',
  Montenegro: 'Montenegro',
  Syria: 'Syrien',
  Ghana: 'Ghana',
  Niger: 'Niger',
  Ethiopia: 'Äthiopien',
  Libya: 'Libyen',
  Mauritania: 'Mauretanien',
  emptyTreasureChest: 'Leere Schatzkiste',
  youGet: 'Du hast erhalten',
  finish: 'Beenden',
  myBox: 'Meine Kiste',
  upgradeChestText: 'Wenn Sie die Schatzkiste verbessern, können Benutzer die entsprechende Stufe der Schatzkiste öffnen, wenn sie jede Stufe erreichen, und jede Stufe kann nur einmal geöffnet werden.',
  nft: 'NFT',
  noPrize: 'Kein Preis...',
  noPrizeText: 'Viel Glück beim nächsten Mal!',
  upgradeChestInfoText: 'Mit jedem Levelaufstieg können Sie zusätzliche Belohnungen erhalten und haben eine bessere Chance, hochwertige Belohnungen zu erhalten. Bitte arbeiten Sie hart daran, Ihr Level zu verbessern und mehr Belohnungen zu erhalten.',
  dailyRewardsInfoText: 'Wenn Sie in jedem Zeitraum einmal erfolgreich reservieren, können Sie eine Schatzkiste erhalten. Sie können in jedem Zeitraum höchstens eine Schatzkiste erhalten. Beim Öffnen der Schatzkiste besteht die Chance auf hochwertige Belohnungen.',
  airdropInProgress: 'Airdrop im Gange',
  airdropModalText: 'Herzlichen Glückwunsch, Sie haben eine Schatzkiste erhalten. Bitte öffnen Sie es und erhalten Sie Ihre Belohnung.',
  go: 'GEHEN',
  chestType: 'Art der Schatzkiste.',
  bonusType: 'Art der Belohnung.',
  icon: 'Symbol',
  badge: 'Abzeichen',
  chestRewards: 'Belohnung aus der Schatzkiste',
  LEVEL_BOX_1: 'LV1-Schatzkiste',
  LEVEL_BOX_2: 'LV2-Schatzkiste',
  LEVEL_BOX_3: 'LV3-Schatzkiste',
  LEVEL_BOX_4: 'LV4-Schatzkiste',
  LEVEL_BOX_5: 'LV5-Schatzkiste',
  LEVEL_BOX_6: 'LV6-Schatzkiste',
  RESERVE_BOX: 'Reservierungsprämie',
  empty: 'Leere Schatzkiste',
  money: 'Bonus',
  medal: 'Medaille',
  'soulPath-text': 'Treten Sie unserer Mailingliste bei, um über unsere neuesten Funktionsveröffentlichungen, NFT-Listen sowie Tipps und Tricks für die Navigation auf der Treasure-Webseite auf dem Laufenden zu bleiben.',
  subscribe: 'abonnieren',
  look: 'Sicht',
  cool: 'Wow cool',
  decoration: 'Abzeichen',
  setAvatar: 'Als Profilbild festlegen',
  rareCommemorative: 'Seltene Gedenkmünze',
  myDecoration: 'Mein Abzeichen',
  invitationLink: 'Einladungslink generieren',
  currency: 'Währung',
  getUsdt: 'Holen Sie sich USDT',
  reserveRandomBadge: 'Zufälliges Abzeichen',
  fiatCurrencyRecharge: 'Einzahlung in Fiat-Währung',
  purchasingPrice: 'Menge',
  maximum: 'Maximal',
  minimum: 'Minimum',
  available: 'Kann empfangen',
  'placeholder-coin': 'Bitte wählen Sie die Währung aus',
  'rechargeUSDT-frenchCurrency': 'Zahlen Sie USDT (Fiat-Währung) ein',
  pleaseEnterCorrectAmount: 'Bitte geben Sie den korrekten Betrag ein.',
  APP_0094: 'Die Menge der Fiat-Bestellungen hat das Limit überschritten.',
  'daily-profit': 'Täglicher Gewinn',
  notificationList: 'Benachrichtigungsliste',
  announcementManagement: 'Ankündigungsmanagement',
  registerNow: 'Jetzt registrieren!',
  andEarnMore: 'und mehr verdienen',
  googleVerify: 'Google-Verifizierung',
  googleAuthenticator: 'Google Authenticator',
  'googleVerify-text1': '1. Laden Sie Google Authenticator auf Ihr Telefon herunter.',
  'googleVerify-text2': '2. Melden Sie sich bei Ihrem Google-Konto an.',
  'googleVerify-text3': '3. Klicken Sie auf das (+)-Symbol in der unteren rechten Ecke.',
  enterGoogleVerification: 'Geben Sie die Google-Verifizierung ein',
  key: 'Schlüssel',
  copied: 'erfolgreich kopiert',
  googleVerificationError: 'Sie haben die Google-Authentifizierung noch nicht abgeschlossen. Bitte führen Sie zunächst die Google-Authentifizierung durch.',
  redirect: 'Umleiten',
  copyLink: 'Link kopieren',
  redirectMsg: 'Wenn Sie nicht weitergeleitet werden, verwenden Sie bitte die Schaltfläche unten.',
  bulletinBoard: 'Bekanntmachung',
  errorMsgNow: 'Bisher sind {jetzt} Fehler aufgetreten',
  errorMsgAccumulation: 'mit insgesamt {accumulation} Fehlern.',
  loginForbidden: 'Das System wird Ihre Anmeldung deaktivieren.',
  history_SUCCESS: 'Bestanden, wird innerhalb von 10 Minuten gutgeschrieben',
  history_FAIL: 'Fehlgeschlagen. Bitte wenden Sie sich an den Community-Manager.',
  history_PENDING: 'ausstehend',
  history_BROADCASTING: 'ausstehend',
  googleCheckTitle: 'Möchten Sie Ihre Google-Verifizierung wirklich deaktivieren?',
  googleCheckText: 'Nachdem Sie diese Einstellung geändert haben, wird der Auszahlungsdienst für {time} deaktiviert, um Ihr Konto zu schützen.',
  liftedGoogle: 'Deaktivieren Sie die Google-Verifizierung',
  loginPassword: 'Passwort',
  emailCheckTitle: 'Sind Sie sicher, dass Sie Ihre E-Mail-Adresse ändern möchten?',
  emailCheckText: 'Nachdem Sie diese Einstellung geändert haben, wird der Auszahlungsdienst für {time} deaktiviert, um Ihr Konto zu schützen.',
  editEmail: 'E-Mail Adresse ändern',
  'placeholder-loginPassword': 'Bitte geben Sie Ihr Login-Passwort ein',
  resetSuccess: 'Zurücksetzen erfolgreich',
  verifyError: 'Verifizierung fehlgeschlagen',
  resetUnlockText: 'Aufgrund von Änderungen an Ihrer E-Mail-Adresse, Ihrem Passwort, Ihrer Wallet-Adresse oder Ihren Google-Verifizierungseinstellungen hat das System Ihre Auszahlungsfunktion vorübergehend gesperrt.Es wird um {time} freigeschaltet',
  changeSuccess: 'Veränderung erfolgreich',
  applicationFailed: 'Die Bewerbung ist fehlgeschlagen',
  hours: 'Std',
  minutes: 'Protokoll',
  second: 'Zweite',
  expectedReturn: 'Erwartete Rückkehr',
  partnerships: 'Partnerschaften',
  teamBenefits: 'Teamvorteile',
  cumulativeIncome: 'Kumuliertes Einkommen',
  todayEarnings: 'Heutiges Ergebnis',
  make: 'Machen',
  reservating: 'Reservieren',
  or: 'ODER',
  alreadyHaveAccount: 'Sie haben bereits ein Konto?',
  google: 'Google',
  apple: 'Apfel',
  withdrawalErrorText: 'Sie haben ausstehende Auszahlungsanfragen. Bitte warten Sie, bis die vorherige Auszahlung gutgeschrieben wird',
  rechargeMaintain: 'Der Einzahlungskanal wird derzeit gewartet.',
  withdrawalErrorTitle: 'Bitte warten Sie, bis die vorherige Auszahlung bearbeitet wurde',
  withdrawSuccessTitle: 'Die Auszahlungsanforderung wurde erfolgreich eingeleitet',
  withdrawSuccessText: 'Auszahlungen werden innerhalb von maximal 96 Stunden bearbeitet. Die Bearbeitungszeit hängt von der Geschwindigkeit der Blockchain ab',
  termsUse: 'Nutzungsbedingungen',
  details: 'Einzelheiten',
  expressway: 'Schnellspur',
  'placeholder-channel': 'Bitte wählen Sie eine Spur aus',
  Zambia: 'Sambia',
  internalMessage: 'Nachricht',
  registrationFailed: 'Registrierung fehlgeschlagen',
  EO_004_9: 'Maximale Registrierungs-IP überschritten',
  'noDataText-1': 'Keine Daten verfügbar',
  'noDataText-2': 'Sie können zum Reservierungsbildschirm zurückkehren, um Vorgänge auszuführen',
  customerNotification: 'Kundenbenachrichtigung',
  systemNotification: 'Systembenachrichtigung',
  notificationDetails: 'Benachrichtigungsdetails',
  allRead: 'Alles gelesen',
  lineSettings: 'Leitungseinstellungen',
  route: 'Route',
  clickButtonWebsite: 'Bitte klicken Sie auf die Schaltfläche unten, um zur Website zu gelangen',
  APP_0104: 'Aufgrund der Auswirkungen lokaler gesetzlicher Vorschriften ist eine Nutzung nicht möglich. Wir bitten um Entschuldigung für die Unannehmlichkeiten.',
  notAvailable: 'Kann nicht verwendet werden.',
  bindingAddress: 'Bitte gehen Sie zunächst zur verlinkten Adresse.',
  'editAddressText-1': 'Sind Sie sicher, dass Sie Ihre Adresse ändern möchten?',
  'editAddressText-2': 'Nachdem Sie diese Einstellung geändert haben, wird der Auszahlungsdienst für {time} deaktiviert, um Ihr Konto zu schützen.',
  editAddress: 'Adresse ändern',
  withdrawalRules: 'Auszahlungsregeln',
  'withdrawalRulesText-1': 'Die zweite Auszahlung kann erst nach Gutschrift der ersten Auszahlung veranlasst werden.',
  'withdrawalRulesText-2': 'Die Gutschrift erfolgt innerhalb von 96 Stunden nach der Auszahlung.',
  goBinding: 'Verbinde jetzt',
  Algeria: 'Algerien',
  APP_0090: 'Wallet-Adresse existiert bereits',
  settingFailed: 'Einstellung fehlgeschlagen',
  anticipatedIncome: 'Erwartetes Einkommen',
  finance: 'Verdienen',
  fixedInvestment: 'Menge',
  dailyIncome: 'Tägliches Einkommen',
  fixedInvestmentPeriod: 'Tage',
  checkDetails: 'Einzelheiten',
  incomeProfit: 'Einkommen',
  limitParticipationDay: 'Teilnahmebeschränkung {day}days/{items}times',
  comingSoon: 'Demnächst',
  comingSoonText: 'Weitere Gewinnmöglichkeiten stehen bevor, bitte bleiben Sie dran.',
  nextRound: 'Nächste Runde',
  investmentType: 'Anlagetyp',
  notification: 'Benachrichtigung',
  'notification-text-1': 'Sie haben neue Möglichkeiten zum Pfandkauf.',
  pledge: 'Einsatz',
  record: 'Aufzeichnen',
  investmentAmount: 'Anlagebetrag',
  applicationTime: 'Bewerbungszeit',
  expirationTime: 'Ablaufdatum',
  increasePrincipal: 'Auftraggeber hinzufügen',
  subscription: 'Abonnieren',
  nextSubscriptionTime: 'Nächster Abo-Zeitpunkt',
  subscriptionQuantity: 'Menge',
  'input-placeholder': 'Bitte geben Sie {input} ein',
  errorInputWithinRange: 'Bitte geben Sie den Betrag innerhalb des Bereichs ein',
  accountBalance: 'Gleichgewicht',
  levelLimit: 'Levelbeschränkung',
  rulesExplanation: 'Erläuterung der Regeln',
  'rules-text-1': '{time} Tage begrenzen {times} Zeiten',
  increaseQuantity: 'Anzahl erhöhen',
  currentPrincipal: 'Aktueller Schulleiter',
  addablePrincipal: 'Zusätzlicher Auftraggeber',
  pledgeRecordStatus_PENDING: 'Ausstehend',
  pledgeRecordStatus_EXPIRE: 'Erlöschen',
  pledgeRecordStatus_RELEASE: 'Freigeben',
  remainCount: 'Verbleibende Zeiten',
  times: 'Mal',
  valuation: 'Bewertung',
  subscriptionSuccess: 'Abonnement erfolgreich',
  subscriptionFailure: 'Das Abonnement ist fehlgeschlagen',
  pledge_1: 'YieldCanvas',
  pledge_2: 'ArtisticAlpha',
  pledge_3: 'WealthVista',
  pledge_4: 'PledgePro',
  pledge_5: 'NFTGemGain',
  pledge_6: 'ProsperNFT-Hub',
  pledge_7: 'CryptoCanvas-Ertrag',
  pledge_8: 'ArtisanAureole-Fonds',
  APP_0103: 'Ihr Abonnementbetrag liegt nicht innerhalb des Limitbereichs.',
  APP_0105: 'Bei diesem Abonnement kann kein Hauptkonto hinzugefügt werden.',
  APP_0106: 'Die Pfahlinstanz wurde noch nicht geöffnet.',
  APP_0107: 'Das maximale aufeinanderfolgende Teilnahmelimit wurde überschritten.',
  APP_0108: 'Das zusätzliche Kapitallimit für diesen Anteil wurde überschritten.',
  APP_0109: 'Ihr Level liegt nicht im Grenzbereich.',
  APP_0110: 'Nicht innerhalb des Einsatzzeitraums.',
  APP_0111: 'Sie können nicht gleichzeitig mit mehreren Einsätzen fortfahren.',
  APP_0112: 'Mit dem Erfahrungskonto können keine Finanzprodukte genutzt werden',
  APP_0113: 'Sie haben eine laufende Bestellung. Bitte warten Sie, bis diese abgeschlossen ist, bevor Sie mit der nächsten fortfahren.',
  pleaseEnterInteger: 'Bitte geben Sie eine Ganzzahl ein.',
  max: 'Max',
  'placeholder-quantity': 'Bitte Menge eingeben',
  pleaseUseNewPasswordToLogin: 'Bitte melden Sie sich mit dem neuen Passwort an.',
  sendFailed: 'Senden fehlgeschlagen',
  modifySuccess: 'Änderung erfolgreich',
  Kyrgyzstan: 'Kirgisistan',
  collectionEd: 'Sammlung',
  addNewCollection: 'Sammlung hinzufügen',
  photoStickers: 'Benutzerbild',
  background: 'Hintergrund',
  backgroundText: 'Dieses Bild wird oben auf der Sammlungsseite angezeigt. Vermeiden Sie zu viel Text in diesem Hintergrundbild, da die Größe auf verschiedenen Geräten unterschiedlich sein kann.',
  nameHint: 'Der Name darf nur Englisch und Zahlen enthalten und muss weniger als 30 Zeichen lang sein.',
  describe: 'Beschreibung',
  describeHint: 'Diese Beschreibung wird in der Sammlung angezeigt.',
  category: 'Kategorie',
  link: 'Verknüpfung',
  blockchain: 'Blockchain',
  blockchainHint: 'Wählen Sie die Standard-Blockchain aus, die Sie dieser Sammlung für neue Elemente hinzufügen möchten.',
  paymentToken: 'Zahlungstoken',
  paymentTokenHint: 'Mit diesen Token können Sie Ihre Artikel kaufen und verkaufen.',
  'describe-placeholder': 'Geben Sie eine detaillierte Beschreibung Ihrer Sammlung...',
  'category-artwork': 'Kunst',
  'category-bscNFT': 'BSC NFT',
  'category-domain': 'Sammlerstücke',
  'category-polygonNFT': 'Polygon-NFT',
  freezeMetadata: 'Metadaten einfrieren',
  'freezeMetadataInfo-1': 'Durch das Einfrieren Ihrer Metadaten können Sie den gesamten Inhalt dieses Elements dauerhaft sperren und im dezentralen Dateispeicher speichern.',
  'freezeMetadataInfo-2': 'Um Ihre Metadaten einzufrieren, müssen Sie zuerst Ihr Element erstellen.',
  freezeMetadataText: 'Sobald Ihre Inhalte gesperrt sind, können sie nicht mehr bearbeitet oder entfernt werden, da sie dauerhaft im dezentralen Dateispeicher gespeichert werden, der für andere Kunden zur Ansicht und Nutzung zugänglich ist.',
  mintNoMoreThan10M: 'Maximale Größenbeschränkung: 10 MB',
  pleaseAddCollectionFirst: 'Bitte fügen Sie zuerst eine Sammlung hinzu.',
  editCollection: 'Sammlung bearbeiten',
  'category-collection': 'Sammlerstücke',
  APP_0114: 'Sie haben einen nicht offenbarten Auftrag; Bitte warten Sie, bis die Bestellung ausgelost ist, bevor Sie eine Reservierung vornehmen.',
  APP_0115: 'Das tägliche Reservierungslimit für dieses Zeitfenster wurde erreicht; Bitte wählen Sie für Ihre Reservierung ein anderes Zeitfenster.',
  Iraq: 'Irak',
  Tunisia: 'Tunesien',
  Armenia: 'Armenien',
  Bahrain: 'Bahrain',
  APP_0116: 'Betrag überschreitet das Limit',
  pledgeValue: 'Einsatzwert',
  pledgeTime: 'Einsatzzeit',
  endTime: 'Endzeit',
  dailyReturn: 'APR',
  durabilityDays: 'Haltbarkeitstage',
  pledgeDetails: 'Pfanddetails',
  rewardAvailable: 'Belohnungen verfügbar',
  nftStake: 'NFT-Anteil',
  close: 'Schließen',
  reservationSuccess: 'Reservierungserfolg',
  chooseYourStakeTime: 'Wählen Sie Ihre Einsatzzeit',
  stakeMsg_stakeSuccess: 'Einsatz erfolgreich',
  stakeMsg_buySuccess: 'Kaufen Sie erfolgreich',
  totalPledgeValue: 'Gesamteinsatzwert',
  totalPledgeIncome: 'Gesamte Pfandeinnahmen',
  redemption: 'Rückzahlung',
  myPledge: 'Mein Anteil',
  APP_0117: 'Die Anzahl der täglichen Einsätze überschreitet das Limit',
  APP_0118: 'Einschränkung auf Stake-Instanzebene.',
  expired: 'Ablauf',
  reviewCountdown: 'Wird überprüft',
  enterStakeDays: 'Geben Sie die Einsatztage ein',
  stakableDays: 'Absteckbare Tage',
  errorOutOfRange: 'Außer Reichweite',
  reciprocal: 'reziprok',
  profit: 'Profitieren',
  pledgeWarning_01: 'Überschreitung des Höchstverdienstes. Überschüsse werden nicht verzinst. Einsatz bestätigen?',
  APP_0120: 'Die verbleibenden Einsatztage für dieses NFT reichen nicht aus, bitte überprüfen Sie es noch einmal.',
  saleSuccessful: 'Verkauf erfolgreich',
  APP_0121: 'Limit für die Höhe des Einsatzprodukts',
  APP_0119: 'Das monatliche Auszahlungslimit wurde überschritten.',
  APP_0123: 'Die Anzahl der monatlichen Einkäufe überschreitet das Limit.',
  dailyReservationIncome: 'Tägliches Reservierungseinkommen',
  dailyActivityRewards: 'Tägliches Aktivitätseinkommen',
  dailyTeamIncome: 'Tägliches Teameinkommen',
  totalBookingRevenue: 'Gesamte Buchungseinnahmen',
  totalActivityProceeds: 'Gesamtaktivitätseinkommen',
  totalTeamRevenue: 'Gesamteinkommen der Mannschaft',
  totalFinancialIncome: 'Gesamter Finanzertrag',
  overallPledgeIncome: 'Gesamte Pfandeinnahmen',
  dailyStakingIncome: 'Tägliches Einsatzeinkommen',
  dailyComprehensiveIncome: 'Tägliches Gesamteinkommen',
  comprehensiveTotalIncome: 'Umfassendes Gesamteinkommen',
  daily: 'Täglich',
  overallRevenue: 'Gesamteinkommen',
  comprehensiveIncome: 'Gesamteinkommen',
  reservationIncome: 'Reservierungseinnahmen',
  teamRevenue: 'Teameinkommen',
  activityRewards: 'Aktivitätseinkommen',
  stakingIncome: 'Einkünfte verpfänden',
  overall: 'Umfassend',
  event: 'Aktivität',
  dailyRevenue: 'Tägliches Einkommen',
  reservation_rules_1: 'Die Bedeutung der Quotenanalyse für den Treasure – NFT-Vorbestellungshandelsmarkt',
  'reservation_rules_1-1': 'Treasure – NFT Pre-Order Trading Market ist eine Plattform, die speziell für die Bereitstellung von Reservierungs- und Handelsdiensten für nicht fungible Token (NFTs) entwickelt wurde. Dieser Markt ermöglicht es Benutzern, vor der offiziellen Veröffentlichung von NFTs Vorbestellungstransaktionen durchzuführen, um sicherzustellen, dass sie den Erhalt bestimmter NFTs nach deren Veröffentlichung priorisieren können. Dieser Mechanismus ist besonders wichtig für beliebte NFTs, da deren Nachfrage das Angebot oft bei weitem übersteigt.',
  'reservation_rules_1-2': 'Basierend auf der Wertsteigerung im Weltmarkt und dem gesamten Emissionsvolumen der Emittenten werden Marktreservierungsquoten für NFTs generiert.',
  'reservation_rules_1-3': 'Prioritätszuteilung: Die Quoten werden auf der Grundlage der historischen Transaktionsaufzeichnungen der Enthusiasten, der Höhe der vorbestellten Handelsgelder, der VIP-Stufen, der Gesamtzahl der Händler in der Community und der Gesamtmenge der vorbestellten Handelsgelder verteilt.',
  'reservation_rules_1-4': 'Optimierung der Ressourcenzuteilung: Das Verständnis der Kontingentzuteilungsregeln ermöglicht eine effizientere Ressourcenverteilung und erhöht dadurch die Chancen auf eine erfolgreiche Reservierung.',
  'reservation_rules_1-5': 'Das Konzept der Marktquoten: Bei jeder NFT-Vorbestellungstransaktion weist die Plattform eine bestimmte Anzahl oder Menge an NFTs zu, mit denen Enthusiasten handeln können. Aufgrund der begrenzten Menge seltener NFTs wird ein Quotensystem verwendet, um die Ressourcen gerecht zu verteilen.',
  reservation_rules_2: 'Strategien zur Verbesserung der Erfolgsquote von Vorbestellungs-Handelsquoten',
  'reservation_rules_2-1': 'Stellen Sie sicher, dass Sie während des Vorbestellungszeitraums ausreichend Mittel investieren, um den Ihnen zugeteilten Anteil zu erhöhen.',
  'reservation_rules_2-2': 'Nehmen Sie aktiv an den von der Plattform organisierten Veranstaltungen teil, um zusätzliche Chancen oder Belohnungen zu erhalten, die Ihre Erfolgswahrscheinlichkeit erhöhen.',
  'reservation_rules_2-3': 'Aktive Enthusiasten oder hochrangige Enthusiasten, die effektive Wachstumsrate der Community-Mitglieder, historische Transaktionsaufzeichnungen und die Höhe der vorbestellten Handelsgelder können zu höheren Quoten oder einer Prioritätszuteilung führen.',
  'reservation_rules_2-4': '99 % Rendite auf Reservierungen + 99 % Erfolgsquote bei Vorbestellungskontingenten: Bitte beachten Sie die Strategien zur Verbesserung der Erfolgsquote bei Vorbestellungshandelsquoten.',
  reservation_rules_3: 'Gründe für verringerte Erfolgsquote und Ertrag',
  'reservation_rules_3-1': 'Risikoverhalten von Enthusiasten, wie der Missbrauch mehrerer Konten, sind wichtige Faktoren. Die Einhaltung der Primärregeln ist von entscheidender Bedeutung, um Strafen zu vermeiden und eine höhere Erfolgsquote und einen höheren Ertrag aufrechtzuerhalten.',
  'reservation_rules_3-2': 'Ein Mangel an langfristigem Wachstum bei aktiven Community-Mitgliedern kann zu einem Rückgang der Erfolgsquote bei Marktreservierungen und damit zu einer geringeren Erfolgsquote führen.',
  'reservation_rules_3-3': 'Unzureichende Handelsmittel vor der Bestellung, die nicht die erforderliche Zuweisung für den reservierten NFT erfüllen, führen zu einer geringeren Erfolgsquote.',
  'reservation_rules_3-4': 'Die intelligente Technologie zur Datenanalyse und Marktwarnung erkennt automatisch und gleicht ab, ob Benutzer die Voraussetzungen für Vorbestellungstransaktionen und die Berechtigung zur Auszahlung von Vorbestellungserträgen erfüllen.',
  'reservation_rules_3-5': 'Treasure – Der NFT-Vorbestellungshandelsmarkt bietet Enthusiasten durch einen angemessenen Quotenzuteilungsmechanismus und wissenschaftliche Reservierungsregeln eine faire Möglichkeit, NFTs zu erhalten. Das Verstehen und Nutzen dieser Mechanismen und Strategien kann die Erfolgsquote von Reservierungen effektiv steigern und sicherstellen, dass Enthusiasten einen Vorteil auf dem hart umkämpften NFT-Markt erlangen.'
}
